import React from 'react';
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Setting from '../../../assets/Setting.png';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';

const AddressesTab = () => {
  const columnWidth = '10%'; 

  return (
    <Box>
      {/* Top Actions */}
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <IconButton sx={{ border: '1px solid black', borderRadius: 1 ,color:""}}>
          <AddIcon />
        </IconButton>
        <IconButton sx={{ border: '1px solid black', borderRadius: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box>

      {/* Table */}
      <TableContainer className='table' sx={{ borderRadius: 2, border: "1px solid black", overflow: 'auto', mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: 'white', borderBottom: '1px solid black' }}>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>
                <img src={Setting} style={{ filter: 'invert()', width: "30px" }} alt='setting' />
              </TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>Address Line 1</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>Address Line 2</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>City/Suburb</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>Province/State</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>Postal Code/Zip</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>Country</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black'}}>Type</TableCell>
              <TableCell sx={{ width: columnWidth,borderBottom:'1px solid black' }}>Default for type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={20} sx={{ textAlign: 'center', padding: '16px', borderBottom: '1px solid black' }}>
                No Addresses Found
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* Bottom Action */}
        <Box sx={{ display: 'flex', gap: 1, p: 2 }}>
          <Button
            sx={{ fontSize: "12px", color: '#7C91E1', fontWeight: "bold", textTransform: 'none' }}
            startIcon={<AddIcon />}
          >
            Add new address
          </Button>
        </Box>
      </TableContainer>
    </Box>
  );
};

export default AddressesTab;
